import React, { useState } from "react";
import "./MenuFilters.css";
import { IoIosRefresh } from "react-icons/io";
import { FaSliders } from "react-icons/fa6";

const filters = [
  { label: "Filter", icon: <FaSliders />, key: "filter" },
  { label: "Starters", key: "starters" },
  { label: "Soup", key: "soup" },
  { label: "Wishlisted", key: "wishlist" },
  { label: "Veg", icon: <div className="veg-dot" />, key: "veg" },
  { label: "High", icon: <IoIosRefresh size={14} />, key: "high" },
];

export default function MenuFilters() {
  const [activeFilter, setActiveFilter] = useState(null);

  return (
    <div className="filter-bar">
      {filters.map((filter) => (
        <button
          key={filter.key}
          className={`filter-btn ${activeFilter === filter.key ? "active" : ""}`}
          onClick={() => setActiveFilter(filter.key)}
        >
          {filter.icon && <span className="icon">{filter.icon}</span>}
          {filter.label}
        </button>
      ))}
    </div>
  );
}
